import React from 'react';
import FilterLine from './filterLine/FilterLine';
import './MenuFilter.scss';
import { GiHamburgerMenu } from 'react-icons/gi';
import { withTranslation } from 'react-i18next';

class MenuFilter extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        
        this.state = {
            toggleMobileMenu: false
        };
        
        this.displayMobileMenu = this.displayMobileMenu.bind(this);
    }

    displayMobileMenu() {
        this.setState((prevState: any) => {
            return {
                toggleMobileMenu: prevState.toggleMobileMenu === true ? false : true
            }
        })
    }

    render() {
        return (
            <div className="MenuFilter">
                <div className='description'>
                    <p>{this.props.t('SampleBikeMenuDescription')} <span className='text-important'>{this.props.t('SampleBikeMenuDescriptionFirstImportant')}</span> {this.props.t('SampleBikeMenuDescriptionInter')} <span className='text-important'>{this.props.t('SampleBikeMenuDescriptionSecondImportant')}</span></p>
                    <p>{this.props.t('SampleBikeMenuDescriptionSecondParagraph')}</p>
                </div>
                <div className={this.state.toggleMobileMenu ? 'mobileMenu' : ''}>
                    <div className='budgetSection'>
                        <h3>{this.props.t('SampleBikeMenuBudget')}</h3>
                        <div className='budgetLine'>
                            <input
                                type='checkbox'
                                checked={this.props.priceCheck}
                                onChange={(e) => this.props.updateFilters('budget', e.target.checked)}
                            />
                            <input 
                                type="number" 
                                className='form-control budgetInput' 
                                placeholder={this.props.t('SampleBikeMenuBudget')} 
                                defaultValue={this.props.price}
                                onChange={(e) => this.props.updatePrice(parseInt(e.target.value))}
                                aria-label="Budget"
                            />
                            <span className='input-group-text'>€</span>
                        </div>
                    </div>
                    <div className='driveSection'>
                        <h3>{this.props.t('SampleBikeMenuDrive')}</h3>
                        <FilterLine code="electric" label={this.props.t('SampleBikeMenuDriveElectric')} updateFilters={this.props.updateFilters} />
                        <FilterLine code="manual" label={this.props.t('SampleBikeMenuDriveManual')} updateFilters={this.props.updateFilters} />
                    </div>
                    <div className='bikeTypeSection'>
                        <h3>{this.props.t('SampleBikeMenuType')}</h3>
                        <FilterLine code="city & touring" label={this.props.t('city & touring')} updateFilters={this.props.updateFilters} />
                        <FilterLine code="mountain" label={this.props.t('mountain')} updateFilters={this.props.updateFilters} />
                        <FilterLine code="road & gravel" label={this.props.t('road & gravel')} updateFilters={this.props.updateFilters} />
                        <FilterLine code="cargo" label={this.props.t('cargo')} updateFilters={this.props.updateFilters} />
                        <FilterLine code="speedelec" label={this.props.t('speedelec')} updateFilters={this.props.updateFilters} />
                    </div>
                </div>
                <div className='logo-section'>
                    <img className='logo' src={require('../../../assets/image/carrefourLogo.png')} alt="logo" />
                    <GiHamburgerMenu className='burgerIcon' onClick={this.displayMobileMenu} />
                </div>
            </div>
        );
    }
}

export default withTranslation()(MenuFilter);